import { render } from "./InputAlerts.vue?vue&type=template&id=189bf67c&scoped=true"
import script from "./InputAlerts.vue?vue&type=script&lang=js"
export * from "./InputAlerts.vue?vue&type=script&lang=js"

import "./InputAlerts.vue?vue&type=style&index=0&id=189bf67c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189bf67c"]])

export default __exports__